<template>
  <div uk-height-viewport="offset-top: true" class="uk-flex uk-flex-center uk-flex-middle">
    <div class="uk-card uk-card-default uk-card-body uk-card-small uk-width-1-3@m uk-width-1-1 uk-margin-small">
      <h2 class="uk-margin-small">Log In</h2>
      <p>Please enter your email address to see your projects.</p>
      <p
        class="uk-text-warning"
        v-if="logInAttempted && !hasProjects"
      >The email you entered has no projects. Please try again.</p>
      <form @submit.prevent="logIn">
        <div class="uk-margin">
          <input class="uk-input" type="text" placeholder="Email" v-model="email" />
        </div>
        <button
          :disabled="!emailValid"
          type="submit"
          class="uk-button uk-button-primary uk-align-right"
        >
          <span v-if="emailValid">Log In</span>
          <span v-if="!emailValid">Please enter a valid email</span>
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import firebase from "firebase";
import router from '@/router'

export default {
  name: "LogIn",
  data() {
    return {
      email: "",
      projects: [],
      projectImages: [],
      logInAttempted: false,
      hasProjects: false
    };
  },
  methods: {
    logIn() {    
      var self = this;
      const projectsRef = firebase.firestore().collection("projects");    
      projectsRef
        .where("email", "==", self.email.toLowerCase())
        .get()
        .then(function(querySnapshot) {                
          self.hasProjects = !querySnapshot.empty;
          self.logInAttempted = true;
        })
        .then(function() {
          if (self.hasProjects && self.logInAttempted) {
              localStorage.email = self.email.toLowerCase()
              router.push('projects')
          }
        })
        .catch(function(error) {        
        });
    }
  },
  computed: {
    emailValid() {
      return /\S+@\S+\.\S+/.test(this.email);
    }
  },
  mounted: function() {},
  components: {},
  filters: {}
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/design-portal/LogIn.vue